import { Capacitor } from "@capacitor/core";
import { createClient } from "@supabase/supabase-js";

console.log("[supabase.ts] Loading...");

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

console.log(
  "[supabase.ts] VITE_SUPABASE_URL:",
  supabaseUrl ? "SET" : "MISSING",
);
console.log(
  "[supabase.ts] VITE_SUPABASE_PUBLISHABLE_KEY:",
  supabasePublishableKey ? "SET" : "MISSING",
);

// In environments without Supabase env vars (e.g. Storybook, Chromatic), fall
// back to harmless placeholders so module import doesn't crash. Stories that
// don't actually call the network will render fine; any real network call will
// fail with a clear "this is a stub client" message.
const isStub = !supabaseUrl || !supabasePublishableKey;

if (isStub) {
  console.warn(
    `[supabase.ts] Missing Supabase environment variables. VITE_SUPABASE_URL: ${supabaseUrl ? "set" : "missing"}, VITE_SUPABASE_PUBLISHABLE_KEY: ${supabasePublishableKey ? "set" : "missing"}. Using stub client — network calls will fail.`,
  );
}

const effectiveUrl = supabaseUrl || "http://localhost:54321";
const effectivePublishableKey =
  supabasePublishableKey || "stub-publishable-key";

console.log("[supabase.ts] Creating Supabase client...");
console.log("[supabase.ts] Platform:", Capacitor.getPlatform());

const isNative = Capacitor.isNativePlatform();

// Persist the auth session in the WebView's localStorage (supabase-js's default
// when `storage` is unset).
//
// We previously used @capacitor/preferences for more durable native storage,
// but in the Android WebView build its native calls never resolve — every
// Preferences get/set/remove hangs, which wedged supabase-js's getSession() and
// _saveSession() and left sign-in ("logging in…") and every authed query stuck
// forever. localStorage works reliably in the WebView and persists across app
// restarts for the app's fixed origin. If durable native storage is needed
// again, restore a *working* Preferences/SQLite adapter as the `storage` option.
export const supabase = createClient(effectiveUrl, effectivePublishableKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: !isNative, // Enable on web for OAuth/password-reset redirects
  },
});

export const isSupabaseStub = isStub;

console.log("[supabase.ts] Supabase client created (localStorage session)");
